import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_DEMANDER_IMPRESSION_ARMES,
    CONTEXT_REMONTER_ARMES_IMPRESSION,
} from '../../../constants/apiUrls.constants';

const impressionRatelier = combineReducers({
    remonterArmes: APIReducer.bind(null, CONTEXT_REMONTER_ARMES_IMPRESSION),
    demanderImpression: APIReducer.bind(null, CONTEXT_DEMANDER_IMPRESSION_ARMES),
});

export default impressionRatelier;
